import Vue from 'vue';
import PromocodesStatic from './promocodes/promocodesStatic'

const state = {
    states: PromocodesStatic.states,
    audience: PromocodesStatic.audience,
    daysInAdvance: PromocodesStatic.daysInAdvance,
    virginPromocode: PromocodesStatic.virginPromocode,

    promocodes: [],
    isLoadingPromocodes: false,
    promocodesPagination: null,
    selectedPromocode: {},
};

const getters = {
    getPromocodeStates: (state) => state.states,
    getPromocodeAudience: (state) => state.audience,
    getPromocodeDaysInAdvance: (state) => state.daysInAdvance,
    getVirginPromocode: (state) => state.virginPromocode,
    getPromocodes: (state) => state.promocodes,
    getIsLoadingPromocodes: (state) => state.isLoadingPromocodes,
    getPromocodesPagination: (state) => state.promocodesPagination,
    getSelectedPromocode: (state) => state.selectedPromocode,
};

const actions = {
    downloadPromocodes: ({rootState, state}, payload) => {
        // paylod:
        // payload.filters: x
        // payload.paginationSettings: y
        // payload.currentPage
        state.isLoadingPromocodes = true
        return axios.get('/api/supplier/getPromocodes', {
            params:{
                'page': payload.currentPage,
                'pageSize': payload.paginationSettings.itemsPerPage,
                's.supplierId': rootState.user.account.supplierId,
                's.id': null,
                's.code': payload.filters.searchString,
                's.promocodeType': payload.filters.promocodeAudience,
                's.promocodeStatus': payload.filters.promocodeStatus,
            }
        }).then(response => {
            state.isLoadingPromocodes = false
            state.promocodes = response.data.result
            state.promocodesPagination = response.pageInfo
            return response
        }).catch(error => {
            state.isLoadingPromocodes = false
            return error
        })
    },

    createPromocode: ({state, rootState}, promocode) => {
        console.log('createPromocode', promocode)

        promocode.bookingPeriodStart = promocode.bookingPeriodStart + " 00:00:01"
        promocode.bookingPeriodFinish = promocode.bookingPeriodFinish + " 23:59:01"
        promocode.validPeriodStart = promocode.validPeriodStart + " 00:00:01"
        promocode.validPeriodFinish = promocode.validPeriodFinish + " 23:59:01"

        return axios.post('/api/supplier/createPromocode', {
            supplierId: rootState.user.account.supplierId,
            promocode: promocode
        }).then(response => {
            Vue.toasted.success('Promocode Created');
            return response
        }).catch(error => {
            return error
        })
    },

    createPromocodeDraft: ({dispatch, state}, promocode) => {
        promocode.status = state.states[0].id // status[0] is draft
        return dispatch('createPromocode', promocode)
    },

    createPromocodeActive: ({dispatch, state}, promocode) => {
        promocode.status = state.states[1].id // status[0] is active
        return dispatch('createPromocode', promocode)
    },

    updatePromocode: ({rootState, state}, promocode) => {
        console.log('createPromocode', promocode)

        promocode.bookingPeriodStart = promocode.bookingPeriodStart + " 00:00:01"
        promocode.bookingPeriodFinish = promocode.bookingPeriodFinish + " 23:59:01"
        promocode.validPeriodStart = promocode.validPeriodStart + " 00:00:01"
        promocode.validPeriodFinish = promocode.validPeriodFinish + " 23:59:01"

        return axios.post('/api/supplier/editPromocode', {
            supplierId: rootState.user.account.supplierId,
            promocode: promocode
        }).then(response => {
            Vue.toasted.success('Promocode Updated');
            return response
        }).catch(error => {
            return error
        })
    },

    updatePromocodeActive: ({state, dispatch}, promocode) => {
        promocode.status = state.states[1].id // status[0] is active
        return dispatch('updatePromocode', promocode)
    },

    updatePromocodePause: ({state, dispatch}, promocode) => {
        promocode.status = state.states[2].id // status[2] is inactive
        return dispatch('updatePromocode', promocode)
    },

    deletePromocode: ({rootState, state}, promocode) => {
        return Vue.dialog.confirm('Delete this promocode?', {okText: 'Yes', cancelText: 'No'}).then(function () {

            // proceed with delete
            return axios.post('/api/supplier/deletePromocode', {
                supplierId: rootState.user.account.supplierId,
                promocode: promocode
            }).then(response => {
                Vue.toasted.success('Promocode Deleted');
                return response
            }).catch(error => {
                return error
            })

        }).catch(function () {

        });

    },

    changeStatusPromocode: ({rootState, state}, promocode) => {
        console.log('deletePromocode', promocode)
        return axios.post('/api/supplier/setStatusPromocode', {
            supplierId: rootState.user.account.supplierId,
            promocode: promocode
        }).then(response => {
            Vue.toasted.success('Promocode Status Updated');
            return response
        }).catch(error => {
            return error
        })
    },

    pausePromocode: ({dispatch, state}, promocode) => {
        console.log('pausePromocode', promocode)
        promocode.status = state.states[2].id // status[2] is inactive
        return dispatch('changeStatusPromocode', promocode).then(response => {
            return response
        })
    },

    resumePromocode: ({dispatch, state}, promocode) => {
        console.log('resumePromocode', promocode)
        promocode.status = state.states[1].id // status[2] is active
        return dispatch('changeStatusPromocode', promocode).then(response => {
            return response
        })
    },

    setSelectedPromocode: ({commit}, promocode) => {
        commit('SET_SELECTED_PROMOCODE', promocode)
    },

    clearSelectedPromocode: ({commit}) => {
        commit('SET_SELECTED_PROMOCODE', {})
    },

    testPromocode: ({state, rootState}, promocode) => {

        return axios.get('/api/Supplier/FindPromocode', {
            params: {
                supplierId: rootState.user.account.supplierId,
                promocode: promocode
            }
        }).then(response => {
            return response
        })
        // return false
    },

    getPromocodeAffectedEvents: ({state, rootState}, promocode) => {
        let promocodeCopy = JSON.parse(JSON.stringify(promocode))
        promocodeCopy.validPeriodStart = promocodeCopy.validPeriodStart + ' ' +promocodeCopy.validPeriodStartTime
        promocodeCopy.validPeriodFinish = promocodeCopy.validPeriodFinish + ' ' +promocodeCopy.validPeriodFinishTime

        return axios.post('/api/Supplier/PromocodePreview', {
            supplierId: rootState.user.account.supplierId,
            promocode: promocodeCopy
        }).then(response => {
            return response
        }).catch(error => {
            return error
        })
    }
};

const mutations = {
    SET_SELECTED_PROMOCODE: (state, selectedPromocode) => {
        state.selectedPromocode = selectedPromocode
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/promocodes.js